import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

export default function AllocationInfo() {
  const { t } = useLanguage();

  return (
    <section className="bg-brand-black py-24 md:py-32 px-6 border-y border-white/5" aria-labelledby="allocation-heading">
      <div className="max-w-5xl mx-auto">
        {/* Intro Section */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-20 md:mb-24"
        >
          <h2 id="allocation-heading" className="text-white/40 font-sans tracking-[0.3em] text-[10px] md:text-xs uppercase mb-4">
            {t.allocationSub}
          </h2>
          <p className="font-serif text-2xl md:text-4xl text-white font-light leading-relaxed">
            {t.allocationIntro}
          </p>
          <div className="w-12 h-[1px] bg-brand-gold/40 mx-auto mt-8"></div>
        </motion.div>

        {/* Info Grid */}
        <div className="grid md:grid-cols-2 gap-16 md:gap-24 mb-20 md:mb-24">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <h3 className="font-serif text-xl md:text-2xl text-brand-gold mb-6 tracking-wide">
              {t.realityTitle}
            </h3>
            <p className="font-sans text-white/70 leading-relaxed text-sm md:text-base font-light">
              {t.realityText}
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <h3 className="font-serif text-xl md:text-2xl text-brand-gold mb-6 tracking-wide">
              {t.offerTitle}
            </h3>
            <p className="font-sans text-white/70 leading-relaxed text-sm md:text-base font-light">
              {t.offerText}
            </p>
          </motion.div>
        </div>

        {/* Live Status Bar */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.6 }}
          className="flex flex-col items-center"
        >
          <div className="inline-flex items-center gap-3 px-6 py-3 border border-brand-gold/20 bg-brand-gold/5 rounded-full" role="status">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-gold opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-brand-gold"></span>
            </span>
            <span className="text-brand-gold uppercase tracking-[0.2em] font-sans text-[10px] md:text-xs font-medium">
              {t.liveStatus}
            </span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}